import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import {
  ApolloInjection,
  IsAuthenticatedQuery,
} from '@zapier/upsells/src/types';

export const isAuthenticatedQuery = gql`
  query upsells_isAuthenticatedQuery {
    isAuthenticated: isAuthenticatedV2
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useIsAuthenticated = ({ skip, useQuery }: Props = {}) => {
  const _useQuery = useQuery || defaultUseQuery;
  const { data, error, loading } = _useQuery<IsAuthenticatedQuery>(
    isAuthenticatedQuery,
    { skip }
  );

  return {
    error: error?.message,
    isAuthenticated: Boolean(data?.isAuthenticated),
    isLoading: loading,
  };
};
